function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
/* eslint-disable no-return-assign */

import camelCase from 'lodash.camelcase';
export default function keysToCamel(input) {
  if (Array.isArray(input)) {
    return input.map(function (v) {
      return keysToCamel(v);
    });
  }
  if (input !== null && _typeof(input) === 'object') {
    var n = {};
    Object.keys(input).forEach(function (k) {
      return n[camelCase(k)] = keysToCamel(input[k]);
    });
    return n;
  }
  return input;
}